<template>
    <div class="modal-container">
        <div class="modal-header">
            Add Tag
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v.form" class="form-wrapper">
                <form-group label="Name" name="name">
                    <md-input v-model="form.name" />
                </form-group>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-primary" @click="addTag">Save</md-button>
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">Cancel</md-button>
        </div>
    </div>
</template>

<script>
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'CreateEditTagModal',
    mixins: [GeneralMixin],
    props: {
        tag: {
            type: Object,
            default: () => {}
        },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    mounted() {
        if (this.tag) 
            this.form = this.tag;
    },
    data() {
        return {
            form: {
                name: null,
                tagId: null
            }
        };
    },
    methods: {
        async addTag() {
            this.$v.form.$touch();
            if (!this.$v.form.$invalid) {
                this.$_handleLoaderState(true, 'SAVING...');
                const payload = {
                    method: 'post',
                    data: this.form
                };

                const api = `/api/teams/settings/tag`;

                if (this.tag?.tagId) {
                    payload.method = 'put';
                }

                try {
                    const response = await handleRequests(api, payload);
                    this.$notify({
                        message: 'Tag saved!',
                        type: 'success'
                    });

                    this.$_handleLoaderState(false);
                    this.resolve(response?.data);
                } catch (e) {
                    const message = 'Cannot save tag.';
                    showErrorMessage(this, message, e);
                } finally {
                    this.$_handleLoaderState(false);
                    this.resolve(null);
                }
            }
        }
    },
    validations: {
        form: {
            name: {
                'Name required': required
            },
            tagId: {}
        }
    }
};
</script>
